import React, {useEffect, useState} from 'react'
import WhiteArrowRight from '../../../../media/felsv/white_right-arrow_icon.svg'
import { useDispatch, useSelector } from 'react-redux'
import {State} from '../../../../reducers'
import { bindActionCreators } from 'redux'
import { actionsGPAgregarProducto } from '../../../../actions/action-creators'
import {
    gp_ap_Clear,
    gp_ap_SetSucursalesSeleccionadas,
    gp_ap_HandleChange,
    gp_ap_ShowModalConfirmacion,
    //gp_ap_setSucursalSeleccionada
 } from '../../../../actions/gestion-producto/agregar-producto/agregarProducto.actions'
import { DICCIONARIO } from '../../../../constants/Diccionario'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import TablaAccesosProducto from './TablaAccesosProducto'
import ModalCargarFileProductos from '../modals/ModalCargarFileProductos'
import { useHistory } from 'react-router-dom'
import { PLANTILLAS } from '../../../../utils/cargas.utils'
import './TablaAccesosProducto.css'

const AgregarProductoManual = () => {
    const [modalCargarFile, setModalCargarFile] = useState<boolean>(false)
    const history = useHistory();
    const [disabled, setDisabled]= useState(true)
    const {formProduct, formErrorProduct} = useSelector((state: State) => state.gestionProducto.agregarProducto)
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionsGPAgregarProducto, dispatch)
    const agregarProducto = () => dispatch(gp_ap_ShowModalConfirmacion(true));
    const {unidadesMedida,impuestosProducto, productos: productosCatalogo} = useSelector(
            (state: State) => state.catalogos
        )
    const selectedRows = useSelector((state: State) => state.gestionProducto.agregarProducto.sucursalesAsignadas);
    const dataSucursales = useSelector((state: State) => state.gestionProducto.agregarProducto.catalogos.sucursales);
    //const { catalogoSucursalFeles } = useSelector((state: State) => state.catalogos)

    // Limpia el formulario al desmontar el componente
    useEffect(() => {
    return () => {
        // Solo limpiar formulario del producto, NO las sucursales
        dispatch(gp_ap_HandleChange({
            sucursal: '',
            codigoSucursal: '',
            codigoProducto: '',
            precioUnitario: '',
            precioSinIVA: '',
            iva: '',
            tipoItem: '',
            unidadMedida: '',
            descripcion: '',
            impuestoDistintoAlIVA: '',
        }));
    };
}, [dispatch]);
;

  useEffect(() => {
    actions.gp_ap_getSucursales();
}, []);

useEffect(() => {
  if (selectedRows && selectedRows.length > 0) {
    setDisabled(false);
  } else {
    setDisabled(true);
  }
}, [selectedRows]);


useEffect(() => {
  actions.gp_ap_HandleChange({
    sucursalesAsignadas: selectedRows,
    codigoSucursal: selectedRows.length > 0 ? selectedRows[0] : ''
  });
}, [selectedRows]);


const RESOURCES_FOLDER = process.env.REACT_APP_RESOURCES_FOLDER;
const UTILITIES = process.env.REACT_APP_UTILITIES;

const handleDescargarPlantilla = () => {
  const fileNames = [PLANTILLAS.PRODUCTOS_XLSX]
  
  fileNames.forEach(fileName => {
    const urlPlantilla = `${UTILITIES}/${RESOURCES_FOLDER}/${fileName}` + '?timestamp=' + new Date().getTime();

    fetch(urlPlantilla)
      .then(response => {
        if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
        return response.blob();
      })
      .then(blob => {
        const urlDescarga = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = urlDescarga;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(urlDescarga);
      })
      .catch(error => {
      });
  });
};


  const submit = async (e: any) => {
  e.preventDefault();
  if (await actions.gp_ap_validacionesAgregarProducto()) {
    return;
  }

  await actions.gp_ap_agregarProducto();
};
    const cancelar = async() => {
        dispatch(gp_ap_HandleChange({
            sucursal: '',
            codigoSucursal: '',
            codigoProducto: '',
            precioUnitario: '',
            precioSinIVA: '',
            iva: '',
            tipoItem: '',
            unidadMedida: '',
            descripcion: '',
            impuestoDistintoAlIVA: '',

        }));
        // Limpiar sucursales seleccionadas
        dispatch(gp_ap_SetSucursalesSeleccionadas([]));
        history.push('/gestion-productos');
    }

    const handleVerProductos = async (item: any) => {
      if (await dispatch((item.idProducto, false, item))) {
        history.push('/gestion-productos/agregar-producto');
      }
    }

    const handlePrevisualizarCargarProductos = () => {
        history.push('/gestion-productos/agregar-producto-nuevo')
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
  let value: any = e.target.value;

  if (e.target.name === 'tipoItem') {
    value = Number(value);
  }

  if (e.target.name === 'precioUnitario') {
    const regex = /^\d*\.?\d{0,2}$/;
    if (!regex.test(value)) return;
  }

  actions.gp_ap_FormHandleChange(e);
  actions.gp_ap_ValidacionesFormOnBlur(e);

  if (e.target.name === 'precioUnitario') {
    const precioUnitario = parseFloat(value) || 0;
    const precioSinIVA = +(precioUnitario / 1.13).toFixed(2);
    const iva = +(precioUnitario - precioSinIVA).toFixed(2);
    actions.gp_ap_FormHandleChange({ target: { name: 'precioSinIVA', value: precioSinIVA.toString() } } as any);
    actions.gp_ap_FormHandleChange({ target: { name: 'iva', value: iva.toString() } } as any);
  }
};

    const handleUnidadDeMedidaChange = (selected: any) => {
        const value = selected ? selected.value : '';
        const fakeEvent = { target: { name: 'unidadMedida', value } } as React.ChangeEvent<HTMLInputElement>;
        actions.gp_ap_FormHandleChange(fakeEvent);
        actions.gp_ap_ValidacionesFormOnBlur(fakeEvent);
    };

   const handleImpuestoDistintoAlIvaChange = (selected: any) => {
    const value = selected ? selected.value || '' : '';
    const fakeEvent = { 
        target: { 
        name: 'impuestoDistintoAlIVA', 
        value 
        } 
    } as React.ChangeEvent<HTMLInputElement>;
    
    actions.gp_ap_FormHandleChange(fakeEvent);
    actions.gp_ap_ValidacionesFormOnBlur(fakeEvent);
    };


  return (
    
    <>
    <form className='card w-form w-100  mt-16' autoComplete='off' onSubmit={submit}>
        {
            modalCargarFile && <ModalCargarFileProductos onAccept={handlePrevisualizarCargarProductos} onClose={()=> setModalCargarFile(false)}/>
        }
        <div className='card-basic w-100'>
            <div className='mb-16'>
                <h3 className='card-title l mb-16'>
                    Información sucursal
                    <span style={{color: 'red'}}>*</span>
                </h3>
                <div className='separador' style={{opacity: '10%'}}></div>
            </div>
            <p className='gp-sucursal-required-note mt-16'>
                Seleccione al menos una sucursal a la que se asignará el producto. Este campo es obligatorio
                <span style={{color: 'red'}}>*</span>
            </p>
            <div className='mt-16'>
                <div className='form-content'>
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                            <TablaAccesosProducto />
                            {disabled && (
                                <p className='alert s'>
                                    Debe seleccionar al menos una sucursal para poder agregar el producto
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form className='card w-form w-100  mt-16' autoComplete='off' onSubmit={submit}>
        <div className='card-basic w-100'>
            <div className='mb-16'>
                <h3 className='card-title l mb-16'>Información del Producto</h3>
                <div className='separador' style={{opacity: '10%'}}></div>
            </div>
            <div className='mt-16'>
                <div className='form-content'>
                    {/* Primera fila */}
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                            <label htmlFor='codigoProducto' className='field-label m'>
                                {DICCIONARIO.CODIGO_PRODUCTO}
                                <span style={{color: 'red'}}>*</span>
                            </label>
                            <input
                                autoComplete='off'
                                type='text'
                                className='m text-field w-input'
                                name='codigoProducto'
                                placeholder={DICCIONARIO.CODIGO_PRODUCTO}
                                id='codigoProducto'
                                value={formProduct.codigoProducto}
                                onChange={handleChange}
                                maxLength={50}
                            />
                            {formErrorProduct.codigoProducto && <p className='alert s'>{formErrorProduct.codigoProducto}</p>}
                        </div>
                        <div className='label-input'>
                            <label htmlFor='descripcion' className='field-label m'>
                                {DICCIONARIO.DESCRIPCION_PRODUCTO}
                                <span style={{color: 'red'}}>*</span>
                            </label>
                            <input
                                autoComplete='off'
                                type='text'
                                className='m text-field w-input'
                                name='descripcion'
                                placeholder={DICCIONARIO.DESCRIPCION_PRODUCTO}
                                id='descripcion'
                                value={formProduct.descripcion}
                                onChange={handleChange}
                                maxLength={80}
                            />
                            {formErrorProduct.descripcion && <p className='alert s'>{formErrorProduct.descripcion}</p>}
                        </div>
                        <div className='label-input'>
                            <label htmlFor='unidadDeMedida' className='field-label m'>
                                {DICCIONARIO.UNIDAD_DE_MEDIDA}
                                <span style={{color: 'red'}}>*</span>
                            </label>
                                <SearchSelect
                                    data={unidadesMedida}
                                    keyNameText='valor'
                                    keyNameValue='codigo'
                                    placeholder='Unidad de medida'
                                    value={formProduct.unidadMedida}
                                    onChange={handleUnidadDeMedidaChange}
                                    name='unidadMedida'
                                    disabled={false}
                                />
                                {formErrorProduct.codigoProducto && <p className='alert s'>{formErrorProduct.unidadMedida}</p>}

                        </div>
                    </div>
                    {/* Segunda fila */}
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                            <label htmlFor='precioUnitario' className='field-label m'>
                                {DICCIONARIO.PRECIO_UNITARIO}
                                <span style={{color: 'red'}}>*</span>
                            </label>
                            <input
                            autoComplete='off'
                            type='text'
                            className='m text-field w-input'
                            name='precioUnitario'
                            placeholder={DICCIONARIO.PRECIO_UNITARIO}
                            id='precioUnitario'
                            value={formProduct.precioUnitario}
                            onChange={handleChange}
                            />

                            {formErrorProduct.precioUnitario && <p className='alert s'>{formErrorProduct.precioUnitario}</p>}
                        </div>
                        <div className='label-input'>
                            <label htmlFor='precioSinIVA' className='field-label m'>
                                {DICCIONARIO.PRECIO_SIN_IVA}
                            </label>
                            <input
                                autoComplete='off'
                                type='text'
                                className='m text-field w-input'
                                name='precioSinIVA'
                                placeholder={DICCIONARIO.PRECIO_SIN_IVA}
                                id='precioSinIVA'
                                value={formProduct.precioSinIVA}
                                readOnly
                            />
                            {formErrorProduct.precioSinIVA && <p className='alert s'>{formErrorProduct.precioSinIVA}</p>}
                        </div>
                        <div className='label-input'>
                            <label htmlFor='iva' className='field-label m'>
                                {DICCIONARIO.IVA}
                            </label>
                            <input
                                autoComplete='off'
                                type='text'
                                className='m text-field w-input'
                                name='iva'
                                placeholder={DICCIONARIO.IVA}
                                id='iva'
                                value={formProduct.iva}
                                readOnly
                            />
                            {formErrorProduct.iva && <p className='alert s'>{formErrorProduct.iva}</p>}
                        </div>
                    </div>
                   {/* Tercera fila */}
                    <div className='w-layout-hflex h-inputs' style={{ alignItems: 'flex-start' }}>
                    {/* Impuesto distinto al IVA */}
                    <div className='label-input responsive-field'>
                    <label htmlFor='impuestoDistintoAlIVA' className='field-label m'>
                        {DICCIONARIO.IMPUESTO_DISTINTO_AL_IVA}
                    </label>
                   <SearchSelect
                    data={[{ idimpuesto: '', descripcion: 'Sin impuesto' }, ...impuestosProducto]}
                    value={formProduct.impuestoDistintoAlIVA || ''}
                    placeholder='Seleccione un impuesto'
                    keyNameText='descripcion'
                    keyNameValue='idimpuesto'
                    disabled={false}
                    name='impuestoDistintoAlIVA'
                    onChange={handleImpuestoDistintoAlIvaChange}
                    />
                    </div>

                    {/* Servicio o Producto */}
                    <div className='label-input responsive-field'>
                    <label htmlFor='tipoItem' className='field-label m'>
                        {DICCIONARIO.SERVICIO_O_PRODUCTO}
                        <span style={{ color: 'red' }}>*</span>
                    </label>
                    <select
                        className='m text-field w-input'
                        name='tipoItem'
                        id='tipoItem'
                        value={formProduct.tipoItem}
                        onChange={handleChange}
                    >
                        <option value=''>Selecciona...</option>
                        <option value='0'>Servicio</option>
                        <option value='1'>Producto</option>
                    </select>

                    {formErrorProduct.tipoItem && <p className='alert s'>{formErrorProduct.tipoItem}</p>}
                    </div>
                    <div
                        style={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        }}
                    >
                        {/* <button
                        type="button"
                        className="button w-auto"
                        style={{ marginTop: '24px', width: '185px' }}
                        onClick={handleDescargarPlantilla}
                        >
                        Descargar plantilla
                        </button> */}

                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='separador mt-16'></div>
            <div className='mt-16 w-100 gp-form-actions'>
            <button
                type='button'
                className='m button transparent w-inline-block w-auto'
                onClick={cancelar}
            >
                Cancelar
            </button>

            <div className='gp-form-actions-buttons'>
                <button
                onClick={agregarProducto}
                type='submit'
                className='m button'
                disabled={disabled}
                title={disabled ? 'Seleccione al menos una sucursal para habilitar esta opción' : undefined}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                }}
                >
                <span>Agregar Producto</span>
                <img src={WhiteArrowRight} loading='lazy' alt='Agregar Producto' />
                </button>

                <button
                    type='button'
                    className='button button-uniform'
                    onClick={handleDescargarPlantilla}
                >
                    Descargar plantilla
                </button>

                <button
                type="button"
                className='button button-uniform'
                onClick={() => setModalCargarFile(true)}
                >
                Cargar plantilla
                </button>

                
            </div>
            </div>
    </form>
    </>
  )
}

export default AgregarProductoManual
